package fyi.moko.hotpl.domain.service

import kotlinx.coroutines.flow.StateFlow

/**
 * Persists the destination-area keywords typed into the Directory tab's "destination
 * area" field (e.g. "Culver City", "Torrance"), most-recent-first, deduplicated
 * case-insensitively, capped at [MAX_ENTRIES]. Survives app restarts — the same few
 * neighborhoods get revisited often enough that only clearing app data (not just the
 * process dying) should lose the history.
 */
interface DestinationHistoryStore {
    val recentDestinations: StateFlow<List<String>>

    suspend fun record(destination: String)

    companion object {
        const val MAX_ENTRIES = 5
    }
}

/**
 * Prepends [destination] to this most-recent-first list, removing any case-insensitive
 * duplicate and capping the result at [maxEntries]. Shared by every platform's
 * [DestinationHistoryStore] so the merge/dedupe/cap rule can't drift between them.
 */
fun List<String>.withRecordedDestination(
    destination: String,
    maxEntries: Int = DestinationHistoryStore.MAX_ENTRIES,
): List<String> =
    (listOf(destination) + filterNot { it.equals(destination, ignoreCase = true) }).take(maxEntries)
